<template>
  <div class="xcard">
    <!-- <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn> -->
    <h3 class="text-primary text-center mt-0">
      <span v-if="estado == 'solicitado'"> Descuentos pendientes de aprobacion </span>
      <span v-else-if="estado == 'aprobado'"> Descuentos aprobados </span>
      <span v-else> Descuentos rechazados </span>
    </h3>

    <div class="table-responsive">
      <v-row dense>
        <v-col cols="3">
          <v-combobox
            v-model="tipo_descuento"
            :items="tipos_des"
            label="* Tipo de descuento"
            hide-details
            outlined
            dense
          ></v-combobox>
        </v-col>
        <v-col cols="3">
          <v-combobox
            v-model="estado"
            :items="['solicitado', 'aprobado', 'rechazado']"
            label="* Estado"
            hide-details
            outlined
            dense
          ></v-combobox>
        </v-col>
        <v-col cols="3">
          <v-combobox
            v-model="filtroprograma"
            :items="programas"
            label="Programa"
            :loading="isloadingprograma"
            placeholder="Seleccione un programa..."
            hide-details
            outlined
            dense
          ></v-combobox>
        </v-col>
        <v-col cols="3">
          <v-combobox
            v-model="filtroestudiante"
            :items="estudiantes"
            label="Carnet estudiante"
            :loading="isloadingestudent"
            placeholder="tecla enter para buscar..."
            hide-details
            outlined
            dense
          ></v-combobox>
        </v-col>
      </v-row>

      <table class="table table-hover" id="midatatable">
        <thead style="background:#196391;">
          <tr class="white--text">
            <th>Nro</th>
            <th>Monto</th>
            <th>Descripcion</th>
            <th>Fecha registro</th>
            <th>Prorrateo</th>
            <th>Estudiante</th>
            <th>Solicitante</th>
            <th>Res.</th>
            <th v-show="false">Programa</th>
            <th>Opciones</th>
          </tr>
        </thead>

        <tbody>
          <tr v-bind:key="ind" v-for="(des, ind) in datos">
            <td>{{ ind + 1 }}</td>
            <td :title="'id:' + des.id">{{ des.monto }} <small>Bs.</small></td>
            <td>{{ des.descripcion }}</td>
            <td>{{ parsefecha(des.fecha_registro) }}</td>
            <td>{{ des.prorrateadoActivo ? 'SI' : 'NO' }}</td>
            <td>
              {{ des.estudiante.nombres }} {{ des.estudiante.primer_apellido }} {{ des.estudiante.segundo_apellido }}
            </td>
            <td>{{ parseuser(des.user_solicitante) }}</td>
            <td>{{ parseuser(des.user_responsable) }}</td>
            <td v-show="false">{{ des.programa.nombre }}</td>
            <td style="min-width: 90px">
              <v-btn
                v-if="des.estado == 'solicitado' && ($store.state.CARGO.id == 14 || $store.state.CARGO.id == 1)"
                :disabled="
                  idrol != 1 &&
                    (tipo_descuento.text == 'Liquidación de Cartera' ||
                      tipo_descuento.text == 'Compensación por cambio de plan')
                "
                small
                depressed
                color="green"
                class="mr-1"
                outlined
                data-toggle="modal"
                data-target="#modal-ndescuentoaprob"
                title="Aprobar"
                @click="aprobardescuento(des)"
              >
                <v-icon dark left> mdi-clipboard-text </v-icon> Dar respuesta
              </v-btn>
              <v-btn
                v-if="des.estado == 'aprobado' && ($store.state.CARGO.id == 14 || $store.state.CARGO.id == 1)"
                :disabled="
                  idrol != 1 &&
                    (tipo_descuento.text == 'Liquidación de Cartera' ||
                      tipo_descuento.text == 'Compensación por cambio de plan')
                "
                small
                depressed
                color="red"
                class="mr-1"
                outlined
                data-toggle="modal"
                data-target="#modal-ndescuentorever"
                title="Revertir"
                @click="revertirdescuento(des)"
              >
                <v-icon dark left> mdi-clipboard-remove </v-icon> Revertir
              </v-btn>
              <v-btn
                small
                depressed
                color="green"
                class="mr-1"
                outlined
                data-toggle="modal"
                data-target="#modal-ndescuentover"
                title="Ver detalles"
                @click="verdescuento(des)"
              >
                <v-icon dark left> mdi-eye </v-icon> Ver
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>

      <v-pagination
        vv-if="datos.length!=0"
        x-small
        v-model="page"
        :length="page_tam"
        prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right"
      ></v-pagination>

      <p class="text-center text-danger">
        <b>{{ msg }}</b>
      </p>
      <div class="text-center">
        <div style="display: inline-block;" v-show="loading" class="loader"></div>
      </div>
    </div>

    <div><ADescuentoAprobacion ref="descuentoestado" v-on:onrespuesta="onrespuesta" /></div>
    <div><ADescuentoReversion ref="ndescuentorever" v-on:onrespuesta="onrespuesta" /></div>
    <div><ADescuentoVer ref="ndescuentover" v-on:onrespuesta="onrespuesta" /></div>
    <div><ABuscarPersona ref="abuscarpersona" v-on:resultadobusquedaest="resultadobusquedaest" /></div>
    <div><ABuscarProgramas ref="abuscarprogramas" v-on:onloadprogramas="onloadprogramas" /></div>
  </div>
</template>

<script>
  import ADescuentoAprobacion from '@/components/ADescuentoAprobacion';
  import ADescuentoReversion from '@/components/ADescuentoReversion';
  import ADescuentoVer from '@/components/ADescuentoVer';
  import ABuscarPersona from '@/components/ABuscarPersona';
  import ABuscarProgramas from '@/components/ABuscarProgramas';
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        insseleccionado: {},
        seleccionado: {},
        programas: [],
        estudiantes: [],
        datos: [],
        estado: 'solicitado',
        timeoutHnd: 0,
        filtroestudiante: '',
        filtroprograma: '',
        buscar: '',
        msg: '',
        isloadingestudent: false,
        isloadingprograma: false,
        loading: false,
        size: 20,
        page: 1,
        page_tam: 0,
        tipo_descuento: { id: 2, text: 'Descuento' },
        tipos_des: [],
        idrol: -1,
      };
    },
    components: { ADescuentoAprobacion, ADescuentoReversion, ADescuentoVer, ABuscarPersona, ABuscarProgramas },
    watch: {
      buscar: function() {
        this.myFunction1(this.buscar.trim());
      },
      estado: function() {
        if (this.page == 1) this.getDatos();
        else this.page = 1;
      },
      'tipo_descuento.id': function() {
        if (this.page == 1) this.getDatos();
        else this.page = 1;
      },
      page: function() {
        this.getDatos();
      },
      '$store.state.CARGO.sede': function() {
        this.getDatos();
      },
      filtroprograma: function() {
        this.getDatos();
      },
      filtroestudiante: function() {
        if (!this.filtroestudiante) {
          this.filtroestudiante = '';
          this.getDatos();
        }
        if (typeof this.filtroestudiante == 'object') {
          this.getDatos();
          return;
        }
        //window.console.log(this.filtroestudiante, typeof this.filtroestudiante);
        if (this.timeoutHnd) {
          clearTimeout(this.timeoutHnd);
          this.timeoutHnd = 0;
        }
        var vue = this;
        this.timeoutHnd = setTimeout(function() {
          if (vue.filtroestudiante.length > 2) {
            vue.estudiantes = [];
            vue.asyncfindestudiante(false);
          } else {
            vue.msg = '';
            vue.estudiantes = [];
          }
          this.timeoutHnd = 0;
        }, 500);
      },
    },
    methods: {
      editar(obj) {
        this.seleccionado = obj;
      },
      modalExitof() {
        this.getDatos();
      },
      aprobardescuento(ins) {
        this.insseleccionado = ins;
        this.$refs.descuentoestado.setdescuento(ins);
      },
      revertirdescuento(ins) {
        this.insseleccionado = ins;
        this.$refs.ndescuentorever.setdescuento(ins);
      },
      verdescuento(ins) {
        this.insseleccionado = ins;
        this.$refs.ndescuentover.setdescuento(ins);
      },
      parsefecha(f) {
        if (!f) return '-';
        let fs = f.split(' ');
        let fs1 = fs[0].split('-');
        let fs2 = fs[1].split(':');
        return `${fs1[2]}/${fs1[1]}/${fs1[0]} ${fs2[0]}:${fs2[1]}`;
      },
      parseuser(u) {
        if (!u) return '-';
        if (!u.segundo_apellido) u.segundo_apellido = '';
        return `${u.nombres} ${u.primer_apellido} ${u.segundo_apellido}`;
      },
      onrespuesta() {
        this.getDatos();
      },
      resultadobusquedaest() {
        window.console.log(this.estudiantes);
      },
      onloadprogramas() {
        this.isloadingprograma = false;
      },
      async getDatos() {
        let idunidad = this.$store.state.CARGO.sede.unidad_negocio;
        let sedeid = this.$store.state.CARGO.sede.id;
        const vue = this;
        let url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/pagos/descuentos?descuento_tipo_id=${this.tipo_descuento.id}&is_asc=false&estado=${this.estado}&page=${this.page}&size=${this.size}&unidad_negocio_id=${idunidad}&sede_id=${sedeid}`;
        if (this.filtroestudiante && typeof this.filtroestudiante == 'object')
          url += `&estudiante_id=${this.filtroestudiante.id}`;
        if (this.filtroprograma && typeof this.filtroprograma == 'object')
          url += `&programa_id=${this.filtroprograma.id}`;
        //window.console.log(">", url);
        vue.loading = true;
        this.datos = [];
        xaxios
          .get(url)
          .then((res) => {
            window.console.log('DESCUENTOS LISTA: ', res.data.data);
            if (res.data == '' || !res.data.data) res.data = { data: { items: [], total: 0 } };
            let total = res.data.data.total;
            let aux = 0;
            let tam = 0;
            while (aux < total) {
              aux += vue.size;
              tam++;
            }
            vue.page_tam = tam;
            //window.console.log(">", aux, total, vue.size, vue.page_tam);
            if (!res.data.data.items) res.data.data.items = [];
            res.data.data.items.forEach((x) => {
              vue.datos.push(x);
            });
            vue.loading = false;
          })
          .catch((error) => {
            window.console.log(error);
            vue.loading = false;
          });
      },
      gettiposdescuentos() {
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/descuento-tipos`;
        xaxios
          .get(url)
          .then((res) => {
            let ff = [];
            vue.idrol = vue.$store.state.CARGO.id;
            res.data.data.forEach((x) => {
              // solicitud de lis, solo master liquidacion y cambio de plan
              /*if (vue.idrol == 1) {
                x.text = x.nombre;
                ff.push(x);
              } else {
                if (x.nombre != 'Liquidación de Cartera' && x.nombre != 'Compensación por cambio de plan') {
                  x.text = x.nombre;
                  ff.push(x);
                }
              }*/
              x.text = x.nombre;
              ff.push(x);
            });
            vue.tipos_des = ff;
            let defa = ff.find((d) => d.id == 2);
            if (defa) vue.tipo_descuento = defa;
          })
          .catch((error) => {
            window.console.log(error);
          });
      },
      asyncfindestudiante() {
        this.$refs.abuscarpersona.asyncfindestudiante(false, this.filtroestudiante, this);
      },
      myFunction1(filtro) {
        filtro = filtro.toUpperCase();
        var table, tr, tdd, td, i, j, txtValue;
        table = document.getElementById('midatatable');
        tr = table.getElementsByTagName('tr');

        for (i = 0; i < tr.length; i++) {
          tdd = tr[i].getElementsByTagName('td');
          for (j = 1; j < tdd.length; j++) {
            td = tdd[j];
            if (td) {
              txtValue = td.textContent;
              if (txtValue.toUpperCase().indexOf(filtro) > -1) {
                tr[i].style.display = '';
                break;
              } else {
                tr[i].style.display = 'none';
              }
            }
          }
        }
      },
    },
    mounted() {
      this.gettiposdescuentos();
      this.$refs.abuscarprogramas.listarprogramasgraphql(this);
      this.getDatos();
    },
  };
</script>
